(function () {
  if (window.__videoTestimonialSplitBound) return;
  window.__videoTestimonialSplitBound = true;

  function updateNavState(root, swiper) {
    var prev = root.querySelector('[data-vts-prev]');
    var next = root.querySelector('[data-vts-next]');
    if (!prev || !next || !swiper) return;

    prev.disabled = swiper.isBeginning;
    next.disabled = swiper.isEnd;

    prev.classList.toggle('vts-nav__btn--active', !swiper.isBeginning);
    next.classList.toggle('vts-nav__btn--active', !swiper.isEnd);
  }

  function mountTestimonialSliders(root) {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('[data-vts-testimonial-slider]').forEach(function (slider) {
      var el = slider.querySelector('.vts-testimonial-swiper');
      if (!el) return;
      if (el.swiper) el.swiper.destroy(true, true);

      var slides = el.querySelectorAll('.swiper-slide');
      if (slides.length < 2) return;

      var prevBtn = slider.querySelector('[data-vts-prev]');
      var nextBtn = slider.querySelector('[data-vts-next]');

      var swiper = new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        speed: 450,
        spaceBetween: 0,
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          swiper.slidePrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          swiper.slideNext();
        });
      }

      swiper.on('slideChange', function () {
        updateNavState(slider, swiper);
      });

      updateNavState(slider, swiper);
    });
  }

  function initSection(root) {
    mountTestimonialSliders(root);
  }

  function boot() {
    document.querySelectorAll('.video-testimonial-split').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!root) return;
    initSection(root);
  });
})();
